module.exports = __webpack_public_path__ + "static/img/LbTu12@2x.6e5ac5fe.png";